import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=7b6ae70a&"
import script from "./informacion.vue?vue&type=script&lang=js&"
export * from "./informacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports